import { useTranslation } from "../../../../locale/useTranslation";

const SaveButton = (props) => {
    const { isLoading, disabled, title, btnColor, onClick, tooltip, style } = props;
    const lang = useTranslation();
    const buttonText = title ?? lang.save_button_text;

    const calculateWidth = () => {
        const baseWidth = 50;
        const perCharWidth = 4;
        return buttonText ? baseWidth + buttonText.length * perCharWidth : baseWidth;
    };

    return <button title={tooltip ? tooltip : lang.save_button_tooltip} style={{ ...style, borderRadius: "4px", width: calculateWidth() }}
        type="submit" onClick={onClick} className={`btn-square btn-${btnColor ?? 'primary'}`} disabled={(isLoading || disabled) ?? false} >
        {isLoading ? <i className="fa fa-spinner fa-spin"></i> : buttonText}
    </button>
}

export default SaveButton;
